import PropTypes from 'prop-types';

const buildField = (id, title, type, req, name, pos, desc, placeholder, value, email, options) => {
  const obj = {
    id,
    title,
    field_type: type || 'text',
    req: req ? 'on' : 'off',
    name: name || '',
    desc_pos: pos ? '1' : '0',
    desc: desc || '',
    placeholder: placeholder || '',
    selected: id === 'dq_email' ? true : false,
    value: value || '',
  };

  if (email) {
    obj.email_conf = email ? 'on' : 'off';
  }
  if (options) {
    obj.repeat = options;
  }
  if (value) {
    obj.value = value;
  }

  return obj;
};

const {
  AdventCount: {
    translations: {
      form: {
        title,
        titleMr,
        titleMs,
        firstName,
        name,
        dailyReminder,
        dailyReminderDesc,
        privacyPolicy,
        privacyPolicyDesc,
        participationConditions,
        participationConditionsDesc,
        newsletter,
        newsletterDesc,
        zipCode,
        email,
        emailDesc,
        street,
        number,
        numberDesc,
        city,
        phone,
        phoneDesc,
        website,
      },
    },
  },
} = window;

const defaultFormSchema = [
  buildField(
    'dq_title',
    title,
    'text',
    true,
    'title',
    true,
    title,
    '',
    false,
    false,
    [
      {
        options: titleMr,
        value: titleMr,
      },
      {
        options: titleMs,
        value: titleMs,
      },
    ],
  ),
  buildField(
    'dq_first_name',
    firstName,
    'text',
    true,
    'first_name',
    true,
    firstName,
    firstName,
  ),
  buildField(
    'dq_name',
    name,
    'text',
    true,
    'name',
    true,
    name,
    name,
  ),
  buildField(
    'dq_email',
    email,
    'email',
    true,
    'email',
    true,
    emailDesc,
    'mail@example.com',
    false,
    true,
  ),
  buildField(
    'dq_daily_reminder',
    dailyReminder,
    'checkbox',
    true,
    'daily_reminder',
    true,
    dailyReminderDesc,
    false,
    'accepted',
  ),
  buildField(
    'dq_privacy',
    privacyPolicy,
    'checkbox',
    true,
    'privacy',
    true,
    privacyPolicyDesc,
    '',
    'accepted',
  ),
  buildField(
    'dq_conditions',
    participationConditions,
    'checkbox',
    true,
    'participation_conditions',
    true,
    participationConditionsDesc,
    '',
    'accepted',
  ),
  buildField(
    'dq_newsletter',
    newsletter,
    'checkbox',
    true,
    'newsletter',
    true,
    newsletterDesc,
    '',
    'accepted',
  ),
  buildField(
    'dq_zip_code',
    zipCode,
    'number',
    true,
    'zip_code',
    true,
    zipCode,
    zipCode,
  ),
  buildField(
    'dq_street',
    street,
    'text',
    true,
    'street',
    true,
    street,
    street,
  ),
  buildField(
    'dq_number',
    number,
    'text',
    true,
    'street_num',
    true,
    numberDesc,
    numberDesc,
  ),
  buildField(
    'dq_city',
    city,
    'city',
    true,
    'city',
    true,
    city,
    city,
  ),
  buildField(
    'dq_phone',
    phone,
    'tel',
    true,
    'phone',
    true,
    phoneDesc,
    phoneDesc,
  ),
  buildField(
    'dq_website',
    website,
    'text',
    true,
    'website',
    true,
    website,
    website,
  ),
];

export const formSchemaPropType = PropTypes.shape({
  desc: PropTypes.string,
  desc_pos: PropTypes.string,
  field_type: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  repeat: PropTypes.arrayOf(PropTypes.shape({
    options: PropTypes.string,
    value: PropTypes.string,
  })),
  value: PropTypes.string,
  req: PropTypes.oneOf(['on', 'off']),
  email_conf: PropTypes.oneOf(['on', 'off']),
});

export default defaultFormSchema;
